import type { OsasResendPatientInviteCustomControlData } from '@common/validation/customControls/osas/osasResendPatientInviteSchema';

export const initialData: OsasResendPatientInviteCustomControlData = {
    patient: { emailAddress: null },
};
